import React from 'react';
import { Button, Box, Modal, TextField, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ModalStyle } from '../style/style';
import { useEmailAction } from '../hooks/useEmailAction';

const ChangeEmailAction = ({ handleUpdateEmailAction, handleResendEmail, refetchDetails }) => {
  const {
    openModal,
    newEmail,
    setNewEmail,
    confirmEmail,
    setConfirmEmail,
    error,
    loading,
    handleOpen,
    handleClose,
    handleSubmitEmailChange,
  } = useEmailAction(handleUpdateEmailAction, handleResendEmail, refetchDetails);

  return (
    <Box>
      <Box display='flex' gap={2} mt={2}>
        <Button variant='contained' onClick={handleOpen}>
          Cambiar Correo
        </Button>
      </Box>

      <Modal open={openModal} onClose={handleClose} aria-labelledby='modal-title'>
        <Box sx={ModalStyle.ModalStyle}>
          <IconButton
            aria-label='close'
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography id='modal-title' variant='h6' component='h2'>
            Cambiar correo electrónico
          </Typography>
          <TextField
            fullWidth
            margin='normal'
            label='Ingrese nuevo correo'
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
          />
          <TextField
            fullWidth
            margin='normal'
            label='Confirmar correo'
            value={confirmEmail}
            onChange={(e) => setConfirmEmail(e.target.value)}
          />
          {error && (
            <Typography color='error' variant='body2'>
              {error}
            </Typography>
          )}
          <Button
            fullWidth
            variant='contained'
            sx={{ mt: 2 }}
            onClick={handleSubmitEmailChange}
            disabled={loading}
          >
            Cambiar y reenviar
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default ChangeEmailAction;
